import axios from 'axios'
import Vue from 'vue';
import router from '../router';
import {
	Notification,
	MessageBox,
	Message
} from 'element-ui'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
export const baseURL = 'http://123.60.143.231:8589'
// export const baseURL = 'http://192.168.0.146:7011/api/sys-manager-web/'
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: baseURL,
})

// request拦截器
service.interceptors.request.use(config => {
	let token = localStorage.getItem("token");
	// if (token === undefined || token === null || token.trim() === '') {
	// 	console.log('login', token)
	// 	router.push({
	// 		path: '/Login'
	// 	})
	// }
	config.headers['Authorization'] = localStorage.getItem("token")
	return config
}, error => {
	console.log('error', error)
	Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(function(response) {
	console.log(response.data.code)
	if (response.data.code == 10002) {
		router.push({
			path: '/Login'
		})
	}
	if (response.data.code == 415) {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 5 * 1000
		})
		localStorage.removeItem("token")
	}
	if (response.data.code != 0) {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 5 * 1000
		})
	} else {
		if (response.data.code === 0 && response.data.hit) {
			Message({
				message: response.data.message,
				type: 'success',
				duration: 5 * 1000
			})
		}
	}
	return response.data;
}, function(error) {
	console.log('error', error)
	Message({
		message: error.message,
		type: 'error',
		duration: 5 * 1000
	})
	return Promise.reject(error);
});

export default service
